import React from "react";
import { useLang } from "../lib/i18n";
import { Euro, Clock, CheckCircle2, ShieldCheck } from "lucide-react";

export const QuoteCard = ({ quote }) => {
  const { t } = useLang();
  if (!quote) return null;
  const fmt = (n) => `€ ${Number(n || 0).toFixed(2)}`;
  return (
    <div data-testid="quote-card" className="overflow-hidden rounded-2xl border border-purple-200 bg-white shadow-sm">
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-4 py-3 text-white">
        <p className="text-xs font-semibold uppercase tracking-wide text-blue-100">{t("quote")}</p>
        <div className="mt-1 flex items-baseline gap-1">
          <Euro className="h-5 w-5" /><span data-testid="quote-total" className="font-display text-3xl font-extrabold">{Number(quote.total || 0).toFixed(2)}</span>
        </div>
      </div>
      <div className="space-y-2 px-4 py-3 text-sm">
        <Line label={t("call_out_fee")} value={fmt(quote.call_out_fee)} />
        <Line label={t("labor")} value={fmt(quote.labor)} />
        {(quote.materials || []).map((m, i) => <Line key={i} label={`${t("materials")}: ${m.desc}`} value={fmt(m.price)} sub />)}
        {quote.urgency_surcharge > 0 && <Line label={t("urgency_surcharge")} value={fmt(quote.urgency_surcharge)} />}
        {quote.surcharges > 0 && <Line label={t("surcharges")} value={fmt(quote.surcharges)} />}
        {quote.discount > 0 && <Line label={t("discount")} value={`- ${fmt(quote.discount)}`} />}
        <div className="mt-2 flex justify-between border-t border-slate-200 pt-2 font-bold text-slate-900">
          <span>{t("total")} (IVA incl.)</span><span>{fmt(quote.total)}</span>
        </div>
      </div>
      <div className="space-y-2 border-t border-slate-100 bg-slate-50 px-4 py-3 text-xs text-slate-600">
        {quote.included && <p className="flex items-start gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /><span><b>{t("included")}:</b> {quote.included}</span></p>}
        {quote.exclusions && <p className="flex items-start gap-2"><span className="mt-0.5 shrink-0 font-bold text-rose-500">✕</span><span><b>{t("exclusions")}:</b> {quote.exclusions}</span></p>}
        {quote.eta && <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-blue-600" /><b>{t("eta")}:</b> {quote.eta}</p>}
        {quote.validity && <p className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-amber-600" /><b>{t("validity")}:</b> {quote.validity}</p>}
      </div>
    </div>
  );
};

const Line = ({ label, value, sub }) => (
  <div className={`flex justify-between ${sub ? "text-slate-500" : "text-slate-700"}`}><span>{label}</span><span className="font-semibold">{value}</span></div>
);
